/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

import React from 'react';
import { Typography } from '@material-ui/core';

const SaveScreenRow = ({ label, text }) => (
  <div className="save row">
    <div className="save-label-savescreen">
      <Typography variant="h6">{label}</Typography>
    </div>
    <div className="save-text-savescreen">
      <Typography style={{ whiteSpace: 'pre-line' }}>{text}</Typography>
    </div>
  </div>
);

export default SaveScreenRow;
